module.exports = __webpack_public_path__ + "img/kyc1-bg.d67ca5dc.png";